import dayjs from 'dayjs';
import humps from 'humps';

const utils = {
  textExcerpt: (text, boundary = 100) => {
    if (text.length <= boundary) return text;
    const shortTextArr = text.slice(0, boundary).split(' ');

    if (shortTextArr.length > 1) shortTextArr.pop();
    return `${shortTextArr.join(' ') }...`;
  },

  checkIfFilterExists: (filterObject, filters, callback) => {
    const filterKey = Object.keys(filterObject)[0];
    if (filters[filterKey] === filterObject[filterKey]) {
      const nullishObject = {};
      nullishObject[filterKey] = null;
      callback(nullishObject);
    } else {
      callback(filterObject);
    }
  },

  getFullName: (user) => {
    const fullName = `${user.firstName || ''} ${user.lastName || ''}`;
    if (!fullName.trim()) return 'Nieznajomy użytkownik';
    return fullName;
  },

  areFiltersSet: (filtersObject, offset = false) => Object.keys(filtersObject).reduce(
      (acc, key) => (typeof filtersObject[key] === 'object'
      ? !!filtersObject[key]?.length : !!filtersObject[key]) + acc, 0,
    ) > +offset,

  getCounterWithSuffix: (count, singularLabel, pluralLabel1, pluralLabel2) => {
    let label = singularLabel;
    if (count % 10 < 5 && count % 10 > 1 && (count % 100 > 14 || count % 100 < 12)) {
      label = pluralLabel1;
    } else if (count !== 1) {
      label = pluralLabel2;
    }
    return `${count} ${label}`;
  },

  formatDateOutput(date, years = false) {
    if (date.length > 1) {
      const outputFormat = years ? 'DD.MM.YY' : 'DD.MM';
      const output = date.map((d) => dayjs(d).format(outputFormat));
      return output.join(' - ');
    }
    return date.length ? dayjs(date[0]).format('DD.MM.YYYY') : '';
  },

  buildFormData(formData, data, parentKey) {
    if (data && typeof data === 'object' && !(data instanceof Date) && !Array.isArray(data)) {
      Object.keys(data).forEach((key) => {
        utils.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
      });
    } else if (data && typeof data === 'object' && Array.isArray(data)) {
      data.forEach((file) => {
        formData.append(`${humps.decamelize(parentKey)}[]`, file);
      });
    } else {
      const value = data === null ? '' : data;
      formData.append(humps.decamelize(parentKey), value);
    }
  },

  parseFileSize(size) {
    if (size === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];

    const i = Math.floor(Math.log(size) / Math.log(k));

    // eslint-disable-next-line no-restricted-properties
    return `${parseFloat((size / Math.pow(k, i)).toFixed(2)) } ${ sizes[i]}`;
  },

  getResponsiveValues(
    xlValue,
    lgValue = xlValue,
    mdValue = lgValue,
    smValue = mdValue,
    defaultValue = smValue,
  ) {
    const {
      xl, lg, md, sm,
    } = this.$vuetify.breakpoint;
    if (xl) return xlValue;
    if (lg) return lgValue;
    if (md) return mdValue;
    if (sm) return smValue;
    return defaultValue;
  },

  allowedDates(val, baseDate) {
    const selectedDate = new Date(val);
    const base = baseDate ? new Date(baseDate) : new Date();


    selectedDate.setHours(0, 0, 0, 0);
    base.setHours(0, 0, 0, 0);

    // Check if selected date is a weekend
    const selectedDayOfWeek = selectedDate.getDay();
    if (selectedDayOfWeek === 0 || selectedDayOfWeek === 6) {
      return false;
    }

    // Check if selected date is earlier than baseDate
    if (selectedDate <= base) {
      return false;
    }

    // Count work days between baseDate and selectedDate (excluding baseDate)
    // 2 next full work days

    const workDaysNeeded = 2; 
    let workDaysCount = 0;
    let currentDate = new Date(base);

    while (currentDate < selectedDate) {
      currentDate.setDate(currentDate.getDate() + 1);
      const dayOfWeek = currentDate.getDay();

      if (dayOfWeek >= 1 && dayOfWeek <= 5) {
        workDaysCount++;
      }
    }

    return workDaysCount >= workDaysNeeded + 1 // + 1 because today is also counted;
  },
};

export default utils;
